<template>
  <CookieTemplate>
    <CookieContent
      slot="content"
      text="Utilizzando questo sito web, accetti il nostro utilizzo dei <a href='https://www.iubenda.com/privacy-policy/23252125/cookie-policy' target='_blank' rel='noopener'>cookie</a>. Utilizziamo i cookie per offrirti una grande esperienza."
    />
    <CookieButton slot="button" label="Accetta" />
  </CookieTemplate>
</template>

<script>
import CookieTemplate from '@/components/Cookie/index.vue';
import CookieContent from '@/components/Cookie/CookieContent/index.vue';
import CookieButton from '@/components/Cookie/CookieButton/index.vue';

export default {
  name: 'Cookie',

  components: {
    CookieTemplate,
    CookieContent,
    CookieButton,
  },
};
</script>

<style>

</style>
